import { functions, db } from '@/vendors/firebase/firebase';
import UserProfile from '@/entities/UserProfile';

export default {
  async createShopUser(userProfile, userPassword, shopId) {
    const { data } = await functions.httpsCallable('createShopUser')({
      userProfile,
      userPassword,
      shopId,
    });
    return new UserProfile(data);
  },
  async softDeleteUser(userId) {
    const { data } = await functions.httpsCallable('deleteUser')({
      userId,
    });
    return data;
  },
  async updateUser(userId, user) {
    await db.collection('users')
      .doc(userId)
      .update(user);
    return user;
  },
  async getUser(userId) {
    const doc = await db.collection('users').doc(userId).get();
    if (!doc) { return null; }
    return new UserProfile(doc.data());
  },
};
